import React from "react";
import './GlobalLoader.scss'
import CircusLogo from '../../../assets/radarr-logo.png'

const GlobalLoader = () => {
  return (
    <div className="global-loader">
      <div className="gooey">
        <span className="dot"></span>
        <div className="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="loader-logo">
        <img src={CircusLogo} alt="Circus Logo" />
      </div>
    </div>
  );
};

export default GlobalLoader;
